export class AuditTrail {
  timestamp: Date;
  content: string;
  userName: number;
  deviceId: string;

  constructor(json?: any) {
    if (!json)
      return;

    this.timestamp = json.timestamp ? new Date(json.timestamp) : null;
    this.content = json.content;
    this.userName = json.userName;
    this.deviceId = json.deviceId;
  }
}
